import firestore from '@paperstac/firebase/lib/firestore';
export var escrowAccountsRef = function escrowAccountsRef() {
  return firestore.collection('escrowAccounts');
};
export var escrowAccountByIdRef = function escrowAccountByIdRef(escrowAccountId) {
  return escrowAccountId ? escrowAccountsRef().doc(escrowAccountId) : null;
};